var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolarBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 984,
    viewBox: "0 0 1440 984",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_165_5834)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 984,
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 984,
    fill: "url(#paint0_radial_165_5834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1359.18 859.358C1117.22 847.853 1173.25 955.078 1014.15 876.236C873.797 893.757 919.319 1132.5 689.144 904.853C655.587 862.454 500.639 891.012 455.993 897.553C421.852 896.794 407.728 882.135 393.605 878.456C340.672 867.652 286.455 861.169 241.692 901.174C216.947 925.41 202.824 931.484 192.261 932.068C181.698 932.652 166.349 929.031 148.665 910.693C99.8757 849.722 41.8066 870.688 -69.1956 863.855C-238.5 862.804 -94.7574 864.848 -29.16 857.198C47.2342 847.795 40.7564 803.819 125.671 842.889C198.33 872.09 211.753 834.012 257.566 818.711C272.857 816.492 279.918 803.702 328.241 830.45C419.926 874.601 479.337 769.829 641.463 857.957C667.609 868.294 864.81 858.482 883.485 823.85C1017.95 730.408 1011.82 836.582 1123.7 853.577C1192.39 857.898 1311.85 855.913 1359.24 859.417L1359.18 859.358Z",
    stroke: "url(#paint1_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1416.38 854.861C1153.23 840.67 1214.16 973.066 1041.12 875.711C888.446 897.319 920.836 1215.66 687.627 920.096C648.058 869.987 482.897 916.942 434.049 911.044C397.165 906.605 381.641 882.485 366.176 878.397C309.04 863.388 248.521 855.913 200.957 906.489C173.41 935.748 158.703 943.865 147.148 944.683C135.593 945.5 117.909 941.763 99.759 918.285C43.3825 845.401 -16.2619 865.082 -137.185 860.41C-321.197 853.343 -164.965 861.87 -93.6485 852.175C-10.5429 840.845 -18.8297 788.751 74.781 834.538C152.809 872.674 166.757 818.478 218.232 804.637C234.514 800.256 241.576 787.7 295.092 819.12C393.08 876.704 452.725 755.988 635.802 853.11C663.349 867.71 878.758 853.752 899.009 810.944C1045.2 695.543 1037.73 832.727 1160.29 847.678C1234.64 856.73 1364.96 850.54 1416.44 854.92L1416.38 854.861Z",
    stroke: "url(#paint2_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473.57 853.869C1189.24 836.932 1255.07 994.557 1068.08 878.689C903.153 904.444 936.827 1288.67 686.109 938.901C643.098 878.923 464.981 935.163 412.047 928.155C372.245 922.899 355.496 886.807 338.688 881.96C277.059 864.089 211.462 855.329 160.163 915.365C130.282 950.289 114.466 959.867 102.035 960.801C89.6044 961.736 70.4036 957.239 50.8528 929.382C-10.3677 842.305 -74.4477 866.016 -205.176 860.468C-404.011 852.058 -235.173 862.22 -158.137 850.657C-68.3199 837.166 -77.541 775.027 23.8316 829.632C107.988 874.952 122.87 810.593 178.838 794.066C196.405 788.868 203.875 773.801 261.885 811.294C367.518 879.624 431.015 735.606 630.025 851.766C659.672 869.053 892.531 852.525 914.417 801.599C1072.4 664.24 1064.11 827.53 1196.77 845.284C1277.01 856.029 1417.95 848.671 1473.57 853.869Z",
    stroke: "url(#paint3_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1530.76 852.876C1225.19 833.253 1295.98 1016.05 1095.04 881.668C917.801 911.511 952.935 1361.61 684.592 957.706C638.195 887.858 447.064 953.385 390.104 945.208C347.384 939.135 329.35 891.07 311.317 885.405C245.194 864.731 174.519 854.686 119.485 924.184C87.3281 964.773 70.4037 975.811 57.0391 976.862C43.6745 977.913 22.9562 972.599 2.00472 940.42C-64.0013 839.152 -132.575 866.951 -273.108 860.527C-486.708 850.774 -305.323 862.571 -222.509 849.138C-125.98 833.487 -136.077 761.303 -26.9422 824.727C63.2835 877.171 79.1577 802.709 139.619 783.437C158.412 777.48 166.407 759.843 228.853 803.468C342.073 882.544 409.48 715.107 624.422 850.365C656.112 870.338 906.538 851.241 930.057 792.197C1099.83 632.878 1090.67 822.215 1233.42 842.889C1319.56 855.329 1471.06 846.802 1530.88 852.876L1530.76 852.876Z",
    stroke: "url(#paint4_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1588.02 851.825C1261.25 829.515 1336.95 1037.48 1122.06 884.529C932.508 918.461 969.276 1434.44 683.133 976.336C633.351 896.677 429.205 971.431 368.218 962.145C322.58 955.195 303.263 895.217 283.945 888.793C213.271 865.315 137.577 853.927 78.8075 932.886C44.3747 979.081 26.3413 991.637 11.9845 992.864C-2.37222 994.09 -24.4909 987.9 -46.843 951.399C-117.576 835.881 -190.761 867.768 -341.04 860.468C-569.463 849.372 -375.473 862.804 -286.939 847.503C-183.699 829.691 -194.729 747.462 -77.8328 819.762C18.5208 879.332 35.2705 794.767 100.284 772.808C120.302 766.033 128.764 745.885 195.704 795.584C316.569 885.347 387.886 694.433 618.703 848.963C652.493 871.564 920.369 849.956 945.523 782.736C1127.08 601.458 1117.1 816.901 1269.95 840.378C1361.98 854.511 1524.11 844.875 1588.02 851.766L1588.02 851.825Z",
    stroke: "url(#paint5_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645.21 850.832C1297.26 825.836 1377.8 1058.97 1149.03 887.508C947.157 925.586 985.617 1507.32 681.615 995.142C628.449 905.612 411.23 989.593 346.275 979.198C297.777 971.431 277.117 899.48 256.516 892.297C181.347 866.016 100.576 853.285 38.0717 941.763C1.36279 993.623 -17.8379 1007.64 -33.0701 1008.98C-48.3022 1010.33 -71.9381 1003.38 -95.7493 962.495C-171.21 832.786 -248.946 868.761 -409.088 860.585C-652.277 848.146 -445.739 863.155 -351.486 846.043C-241.535 826.07 -253.498 733.796 -128.782 814.915C-26.3001 881.609 -8.67497 786.941 60.891 762.296C82.1343 754.762 91.1218 731.985 162.497 787.817C291.007 888.267 366.176 673.876 612.983 847.678C648.817 872.908 934.201 848.788 960.988 773.45C1154.34 570.213 1143.48 811.761 1306.48 838.1C1404.41 853.927 1577.1 843.123 1645.21 850.832Z",
    stroke: "url(#paint6_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1702.4 849.839C1333.27 822.098 1418.71 1080.47 1175.99 890.486C961.864 932.652 1002.02 1580.26 680.098 1013.89C623.605 914.489 393.314 1007.76 324.331 996.251C272.915 987.666 250.972 903.743 229.086 895.742C149.424 866.6 63.5756 852.642 -2.66387 950.523C-41.5905 1008.05 -61.9585 1023.52 -78.1244 1025.04C-94.2903 1026.56 -119.385 1018.74 -144.597 973.533C-224.785 829.574 -307.074 869.696 -477.02 860.585C-735.033 846.802 -515.947 863.447 -415.916 844.466C-299.253 822.332 -312.093 719.955 -179.672 810.009C-71.1211 883.77 -52.5622 779.115 21.556 751.666C44.0248 743.373 53.5374 718.027 129.348 779.933C265.504 891.071 344.582 653.085 607.264 846.276C645.199 874.192 948.091 847.503 976.512 764.048C1181.65 538.911 1169.92 806.447 1343.02 835.706C1446.84 853.226 1630.15 841.254 1702.4 849.839Z",
    stroke: "url(#paint7_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1759.6 848.788C1369.22 818.361 1459.62 1101.9 1202.95 893.406C976.512 939.719 1018.47 1653.09 678.581 1032.64C618.703 923.366 375.397 1025.92 302.388 1013.3C248.054 1003.9 224.885 908.007 201.715 899.247C117.559 867.301 26.6915 852 -43.3997 959.4C-84.6024 1022.59 -106.079 1039.53 -123.179 1041.16C-140.279 1042.8 -166.891 1034.21 -193.504 984.629C-278.418 826.479 -365.259 870.63 -545.01 860.702C-817.788 845.576 -586.154 863.855 -480.405 843.006C-357.089 818.711 -370.803 706.289 -230.562 805.162C-115.884 886.048 -96.4497 771.348 -17.7794 741.154C5.91506 732.044 15.8949 704.128 96.1993 772.165C240 893.991 322.989 632.469 601.545 844.933C641.58 875.477 961.922 846.277 991.978 754.645C1208.85 507.549 1196.3 801.132 1379.55 833.253C1489.27 852.467 1683.14 839.327 1759.54 848.729L1759.6 848.788Z",
    stroke: "url(#paint8_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1816.85 847.795C1405.29 814.681 1500.59 1123.39 1229.97 896.385C991.219 946.785 1034.99 1726.03 677.122 1051.44C613.917 932.302 357.538 1044.14 280.502 1030.36C223.309 1020.14 198.797 912.328 174.344 902.751C85.6941 868.002 -10.251 851.358 -84.0774 968.219C-127.556 1037.07 -150.2 1055.41 -168.233 1057.22C-186.267 1059.03 -214.338 1049.57 -242.352 995.667C-331.935 823.266 -423.387 871.564 -612.942 860.702C-900.486 844.233 -656.304 864.147 -544.835 841.429C-414.808 814.974 -429.398 692.448 -281.453 800.256C-160.647 888.267 -140.337 763.522 -57.1147 730.584C-32.1947 720.714 -21.6895 690.228 63.0503 764.398C214.496 896.911 301.396 611.737 595.884 843.648C637.962 876.82 975.812 845.109 1007.5 745.359C1236.16 476.304 1222.74 795.993 1416.14 830.975C1531.76 851.883 1736.25 837.633 1816.79 847.853L1816.85 847.795Z",
    stroke: "url(#paint9_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1874.04 846.744C1441.3 810.885 1541.5 1144.82 1256.94 899.305C1005.93 953.852 1051.51 1798.92 675.605 1070.13C609.073 941.12 339.622 1062.24 258.559 1047.35C198.447 1036.31 172.652 916.533 146.915 906.138C53.7709 868.586 -47.1931 850.657 -124.813 976.979C-170.568 1051.44 -194.321 1071.3 -213.288 1073.28C-232.255 1075.27 -261.786 1064.93 -291.2 1006.71C-385.511 820.113 -481.514 872.499 -680.874 860.76C-983.241 842.948 -726.454 864.439 -609.266 839.969C-472.526 811.353 -488.05 678.723 -332.285 795.409C-205.351 890.486 -184.224 755.755 -96.3913 720.013C-70.2457 709.384 -59.2159 676.27 30.0177 756.572C189.109 899.714 279.919 591.004 590.281 842.305C634.46 878.047 989.819 843.882 1023.14 736.015C1263.59 445.001 1249.29 790.737 1452.79 828.581C1574.3 851.182 1789.36 835.764 1874.04 846.86L1874.04 846.744Z",
    stroke: "url(#paint10_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1931.24 845.692C1477.31 807.148 1582.41 1166.26 1283.9 902.225C1020.57 960.86 1068.02 1871.8 674.087 1088.88C604.229 949.997 321.705 1080.41 236.615 1064.35C173.586 1052.43 146.506 920.738 119.543 909.584C21.9059 869.228 -84.1357 849.956 -165.491 985.739C-213.521 1065.87 -238.383 1087.18 -258.284 1089.28C-278.185 1091.39 -309.175 1080.29 -340.047 1017.68C-439.027 816.842 -539.641 873.316 -748.806 860.702C-1065.94 841.546 -796.603 864.673 -673.696 838.334C-530.245 807.557 -546.645 664.824 -383.176 790.445C-250.114 892.589 -228.111 747.87 -135.726 709.384C-108.355 697.996 -96.8583 662.254 -3.131 748.688C163.606 902.517 258.325 570.155 584.562 840.845C630.842 879.215 1003.65 842.539 1038.61 726.496C1290.84 413.523 1275.67 785.306 1489.33 826.07C1616.73 850.365 1842.41 833.779 1931.24 845.692Z",
    stroke: "url(#paint11_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1988.43 844.7C1513.26 803.468 1623.32 1187.75 1310.86 905.204C1035.22 967.927 1084.6 1944.69 672.57 1107.68C599.385 958.991 303.847 1098.63 214.671 1081.46C148.782 1068.73 120.419 925.06 92.1136 913.146C-10.0176 869.988 -121.136 849.372 -206.226 994.674C-256.475 1080.47 -282.562 1103.24 -303.339 1105.46C-324.173 1107.74 -356.622 1095.77 -388.895 1028.84C-492.602 813.806 -597.768 874.368 -816.738 860.819C-1148.64 840.32 -866.753 865.082 -738.068 836.874C-587.906 803.936 -605.239 651.1 -433.95 785.598C-294.76 894.867 -271.882 740.103 -174.945 698.813C-146.348 686.666 -134.326 648.296 -36.163 740.862C138.219 905.32 236.907 549.364 578.959 839.502C627.282 880.5 1017.66 841.313 1054.19 717.151C1318.21 382.22 1302.17 780.108 1525.98 823.734C1659.22 849.722 1895.52 832.027 1988.55 844.758L1988.43 844.7Z",
    stroke: "url(#paint12_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2045.62 843.648C1549.26 799.672 1664.18 1209.24 1337.82 908.123C1049.87 974.993 1101.11 2017.57 671.052 1126.37C594.542 967.81 285.93 1116.73 192.727 1098.4C123.92 1084.85 94.2731 929.206 64.6842 916.475C-41.9409 870.572 -158.079 848.613 -246.962 1003.32C-299.487 1094.77 -326.683 1119.01 -348.451 1121.41C-370.22 1123.8 -404.128 1111.07 -437.86 1039.76C-546.236 810.477 -656.012 875.185 -884.787 860.76C-1231.51 838.918 -937.078 865.315 -802.615 835.239C-645.741 800.14 -663.95 637.258 -484.957 780.575C-339.697 896.91 -315.944 732.161 -214.397 688.126C-184.574 675.219 -172.027 634.221 -69.4287 732.978C112.598 908.124 215.255 528.457 573.181 838.1C623.605 881.726 1031.43 840.028 1069.66 707.749C1345.47 350.858 1328.54 774.793 1562.45 821.281C1701.59 848.963 1948.51 830.099 2045.62 843.648Z",
    stroke: "url(#paint13_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2102.87 842.597C1585.33 795.935 1705.15 1230.67 1364.84 910.985C1064.64 981.943 1117.75 2090.4 669.593 1145.06C589.756 976.628 268.072 1134.84 170.843 1115.39C99.1756 1101.02 68.1859 933.47 37.3714 919.921C-73.7474 871.214 -194.963 847.912 -287.581 1012.14C-342.382 1109.26 -370.686 1134.95 -393.389 1137.47C-416.033 1140.04 -451.458 1126.43 -486.591 1050.8C-599.636 807.323 -714.023 876.061 -952.602 860.76C-1314.09 837.575 -1007.11 865.608 -866.928 833.662C-703.343 796.402 -722.485 623.417 -535.672 775.669C-384.285 899.071 -359.656 724.335 -253.557 677.555C-222.509 663.831 -209.436 620.322 -102.402 725.152C87.3283 910.927 193.837 507.666 567.637 836.757C620.162 883.011 1045.44 838.801 1085.3 698.346C1372.84 319.497 1355.04 769.479 1599.16 818.886C1744.19 848.204 2001.68 828.23 2102.99 842.656L2102.87 842.597Z",
    stroke: "url(#paint14_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2160.07 841.604C1621.34 792.255 1746.06 1252.17 1391.81 913.964C1079.29 989.068 1134.38 2163.34 668.076 1163.8C584.912 985.505 250.155 1153 148.841 1132.38C74.2557 1117.2 41.9825 937.675 9.88405 923.366C-105.729 871.856 -231.963 847.269 -328.375 1020.9C-385.452 1123.68 -414.924 1150.78 -438.502 1153.53C-462.08 1156.21 -498.964 1141.85 -535.497 1061.84C-653.269 804.169 -772.208 876.996 -1020.59 860.819C-1396.84 836.29 -1077.32 865.9 -931.417 832.144C-761.12 792.723 -781.138 609.576 -586.621 770.764C-429.106 901.291 -403.66 716.509 -292.95 666.926C-260.676 652.443 -247.137 606.306 -135.61 717.268C61.7663 913.73 172.243 486.758 561.859 835.297C616.485 884.121 1059.27 837.458 1100.7 688.885C1400.04 288.077 1381.36 764.106 1635.64 816.375C1786.56 847.386 2054.67 826.245 2160.07 841.488L2160.07 841.604Z",
    stroke: "url(#paint15_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2217.26 840.553C1657.29 788.518 1786.97 1273.6 1418.77 916.884C1093.93 996.076 1150.95 2236.23 666.559 1182.55C580.068 994.382 232.238 1171.16 126.897 1149.44C49.4521 1133.44 15.8947 941.938 -17.546 926.812C-137.652 872.499 -268.906 846.569 -369.111 1029.72C-428.405 1138.11 -459.045 1166.72 -483.557 1169.59C-508.068 1172.45 -546.411 1157.21 -584.404 1072.87C-706.845 800.957 -830.394 877.872 -1088.58 860.819C-1479.66 834.947 -1147.53 866.192 -995.906 830.567C-818.898 788.985 -839.791 595.735 -637.512 765.858C-473.869 903.452 -447.606 708.742 -332.286 656.356C-298.787 641.113 -284.722 592.348 -168.759 709.442C36.2623 916.533 150.708 465.909 556.198 833.954C612.867 885.405 1073.16 836.231 1116.29 679.541C1427.41 256.774 1407.8 758.908 1672.23 814.039C1828.99 846.744 2107.72 824.493 2217.32 840.553L2217.26 840.553Z",
    stroke: "url(#paint16_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2274.46 839.502C1693.3 784.722 1827.88 1295.03 1445.73 919.804C1108.64 1003.14 1167.53 2309.17 665.041 1201.3C575.224 1003.32 214.321 1189.33 104.953 1166.49C24.5905 1149.67 -10.2508 946.201 -44.9754 930.316C-169.576 873.2 -305.906 845.926 -409.847 1038.53C-471.417 1152.59 -503.166 1182.67 -528.669 1185.65C-554.115 1188.63 -593.917 1172.56 -633.31 1083.91C-760.42 797.804 -888.58 878.806 -1156.63 860.877C-1562.47 833.662 -1217.79 866.542 -1060.45 829.048C-876.733 785.306 -898.56 581.952 -688.52 760.952C-518.748 905.613 -491.61 700.916 -371.737 645.785C-337.013 629.783 -322.423 578.39 -202.024 701.617C10.7005 919.337 129.056 445.06 550.362 832.611C609.132 886.69 1086.87 835.005 1131.64 670.138C1454.55 225.412 1434.06 753.594 1708.65 811.645C1871.3 846.043 2160.65 822.624 2274.4 839.56L2274.46 839.502Z",
    stroke: "url(#paint17_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2331.71 838.451C1729.37 780.984 1868.85 1316.47 1472.75 922.724C1123.35 1010.15 1184.22 2382.06 663.582 1219.99C570.439 1012.14 196.463 1207.43 83.0681 1183.43C-0.154309 1165.79 -36.338 950.348 -72.2882 933.703C-201.382 873.784 -342.732 845.225 -450.466 1047.29C-514.312 1167.02 -547.228 1198.55 -573.607 1201.71C-599.986 1204.86 -641.247 1187.98 -682.099 1094.95C-813.878 794.591 -946.649 879.741 -1224.5 860.877C-1645.11 832.377 -1287.88 866.834 -1124.82 827.472C-934.393 781.568 -957.096 568.111 -739.293 756.047C-563.394 907.773 -535.439 693.09 -410.956 635.156C-375.006 618.395 -359.89 564.374 -235.056 693.791C-14.6862 922.198 107.638 424.21 544.76 831.209C605.63 887.917 1100.88 833.72 1147.22 660.736C1481.92 194.051 1460.56 748.279 1745.3 809.192C1913.84 845.225 2213.82 820.697 2331.65 838.451L2331.71 838.451Z",
    stroke: "url(#paint18_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2388.9 837.399C1765.37 777.246 1909.7 1337.9 1499.66 925.644C1137.94 1017.16 1200.79 2454.94 662.006 1238.73C565.536 1021.01 178.488 1225.59 61.066 1200.48C-25.0745 1182.03 -62.4836 954.67 -99.7761 937.149C-233.364 874.485 -379.791 844.525 -491.26 1056.05C-557.324 1181.44 -591.407 1214.44 -618.72 1217.71C-646.033 1220.98 -688.752 1203.28 -731.006 1105.93C-867.511 791.379 -1004.83 880.558 -1292.49 860.877C-1727.92 831.034 -1358.15 867.068 -1189.31 825.895C-992.17 777.831 -1015.81 554.27 -790.242 751.083C-608.215 909.934 -579.385 685.264 -450.349 624.527C-413.174 607.006 -397.533 550.357 -268.264 685.907C-40.2482 924.943 86.1028 403.303 538.982 829.808C601.953 889.085 1114.65 832.435 1162.68 651.333C1509.17 162.689 1486.88 742.965 1781.77 806.797C1956.21 844.524 2266.75 818.886 2388.78 837.458L2388.9 837.399Z",
    stroke: "url(#paint19_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2446.09 836.407C1801.32 773.508 1950.61 1359.39 1526.62 928.622C1152.59 1024.28 1217.37 2527.88 660.489 1257.48C560.751 1029.89 160.629 1243.76 39.1221 1217.48C-49.878 1198.2 -88.6294 958.874 -127.206 940.595C-265.287 875.127 -416.733 843.824 -531.996 1064.81C-600.336 1195.87 -635.528 1230.32 -663.774 1233.77C-692.021 1237.21 -736.2 1218.7 -779.912 1116.97C-921.087 788.226 -1063.02 881.493 -1360.48 860.877C-1810.68 829.691 -1428.36 867.36 -1253.74 824.376C-1049.95 774.151 -1074.4 540.487 -841.074 746.235C-652.919 912.153 -623.272 677.497 -489.626 613.956C-451.225 595.676 -435.059 536.399 -301.354 678.081C-65.635 927.747 64.6261 382.453 533.38 828.464C598.452 890.37 1128.6 831.209 1178.27 641.93C1536.48 131.328 1513.37 737.65 1818.42 804.344C1998.7 843.765 2319.92 816.959 2446.09 836.348L2446.09 836.407Z",
    stroke: "url(#paint20_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2503.29 835.355C1837.33 769.771 1991.52 1380.82 1553.58 931.542C1167.29 1031.29 1234 2600.83 658.972 1276.23C555.907 1038.77 142.713 1261.98 17.1787 1234.53C-74.7394 1214.44 -114.775 963.138 -154.577 944.099C-297.152 875.828 -453.676 843.24 -572.673 1073.69C-643.29 1210.35 -679.649 1246.33 -708.829 1249.89C-738.009 1253.45 -783.647 1234.12 -828.76 1128.06C-974.604 785.072 -1121.15 882.486 -1428.42 860.936C-1893.38 828.406 -1498.51 867.71 -1318.17 822.858C-1107.67 770.472 -1132.99 526.705 -891.965 741.33C-697.682 914.314 -667.218 669.73 -528.961 603.386C-489.334 584.347 -472.643 522.441 -334.503 670.255C-91.1388 930.55 43.0908 361.546 527.66 827.121C594.833 891.654 1142.49 830.041 1193.73 632.586C1563.74 100.025 1539.69 732.453 1854.96 802.008C2041.13 843.123 2372.91 815.149 2503.23 835.414L2503.29 835.355Z",
    stroke: "url(#paint21_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2560.48 834.304C1873.34 766.033 2032.43 1402.26 1580.55 934.462C1181.94 1038.36 1250.63 2673.71 657.454 1294.97C551.063 1047.7 124.796 1280.14 -4.76487 1251.52C-99.5427 1230.62 -140.92 967.343 -182.006 947.486C-329.075 876.412 -490.618 842.481 -613.468 1082.39C-686.302 1224.72 -723.828 1262.09 -753.942 1265.83C-784.056 1269.57 -831.153 1249.42 -877.666 1138.98C-1028.18 781.802 -1179.33 883.245 -1496.41 860.877C-1976.13 827.004 -1568.72 867.944 -1382.66 821.223C-1165.44 766.676 -1191.71 512.805 -942.855 736.307C-742.445 916.358 -711.105 661.787 -568.296 592.698C-527.444 572.9 -510.227 508.367 -367.594 662.312C-116.526 933.295 21.6723 340.58 521.999 825.602C591.215 892.706 1156.38 828.639 1209.26 623.067C1591.05 68.6045 1566.07 727.021 1891.55 799.497C2083.62 842.247 2426.02 813.163 2560.48 834.246L2560.48 834.304Z",
    stroke: "url(#paint22_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2617.73 846.393C1909.41 775.377 2073.4 1436.83 1607.57 950.464C1196.65 1058.45 1267.32 2759.68 655.995 1326.74C546.277 1069.6 106.938 1311.33 -26.65 1281.6C-124.346 1259.87 -166.949 984.688 -209.378 964.014C-360.94 890.194 -527.561 854.862 -654.145 1104.29C-729.255 1252.28 -767.89 1291.12 -798.938 1295.03C-829.986 1298.89 -878.542 1277.92 -926.514 1163.16C-1081.7 791.73 -1237.46 897.319 -1564.34 874.017C-2058.89 838.801 -1638.87 881.318 -1447.09 832.786C-1223.16 776.078 -1250.3 512.046 -993.746 744.542C-787.208 931.659 -755.051 667.16 -607.632 595.209C-565.554 574.652 -547.87 507.491 -400.743 667.627C-142.029 949.238 0.137203 332.871 516.338 837.4C587.655 907.131 1134.03 827.822 1224.84 626.804C1512.32 -9.30281 1592.57 734.847 1928.14 810.184C2126.04 854.628 2479.07 824.434 2617.67 846.335L2617.73 846.393Z",
    stroke: "url(#paint23_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2674.93 845.634C1945.36 771.932 2114.31 1458.56 1634.53 953.677C1211.36 1065.81 1283.96 2832.86 654.478 1345.78C541.433 1078.77 89.0207 1329.78 -48.5939 1298.89C-149.149 1276.34 -193.095 989.185 -236.749 967.751C-392.805 891.129 -564.444 854.511 -694.822 1113.35C-772.208 1267 -812.011 1307.3 -843.934 1311.33C-875.916 1315.36 -925.931 1293.57 -975.304 1174.43C-1135.15 788.81 -1295.53 898.488 -1632.21 874.309C-2141.53 837.75 -1708.96 881.902 -1511.46 831.501C-1280.82 772.633 -1308.84 498.497 -1044.52 739.87C-831.853 934.054 -798.821 659.568 -646.85 584.873C-603.546 563.556 -585.337 493.825 -433.775 660.035C-167.416 952.275 -21.2811 312.197 510.735 836.29C584.153 908.649 1146.75 826.479 1240.42 617.694C1536.25 -41.8321 1619.01 729.824 1964.79 808.082C2168.59 854.219 2532.23 822.858 2674.98 845.634L2674.93 845.634Z",
    stroke: "url(#paint24_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2732.12 844.933C1981.37 768.544 2155.22 1480.34 1661.49 956.947C1226 1073.17 1300.59 2906.15 652.961 1364.88C536.648 1088 68.0692 1272.78 -70.5375 1316.29C-176.521 1311.33 -219.24 993.798 -264.178 971.548C-424.729 892.122 -601.387 854.161 -735.558 1122.51C-815.22 1281.83 -856.131 1323.59 -889.046 1327.74C-921.903 1331.88 -973.436 1309.28 -1024.27 1185.82C-1188.79 786.007 -1353.71 899.714 -1700.26 874.66C-2224.34 836.757 -1779.28 882.544 -1576.01 830.275C-1338.66 769.245 -1367.55 485.006 -1095.53 735.314C-876.732 936.624 -842.883 652.151 -686.301 574.652C-641.772 552.577 -623.038 480.217 -467.04 652.56C-192.978 955.429 -42.8744 291.698 504.899 835.297C580.418 910.226 1159.3 825.252 1255.77 608.7C1560 -74.2449 1645.27 724.919 2001.21 806.038C2210.9 853.81 2585.11 821.339 2732.06 844.933L2732.12 844.933Z",
    stroke: "url(#paint25_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2789.31 844.232C2017.38 765.157 2196.08 1502.12 1688.46 960.217C1240.65 1080.52 1317.22 2979.38 651.443 1383.92C531.804 1097.23 50.036 1288.61 -92.4809 1333.64C-201.44 1328.5 -245.386 998.354 -291.608 975.343C-456.652 893.114 -638.387 853.869 -776.293 1131.63C-858.173 1296.61 -900.31 1339.83 -934.101 1344.15C-967.892 1348.47 -1020.88 1325.05 -1073.12 1197.21C-1242.3 783.145 -1411.84 900.999 -1768.19 875.069C-2307.1 835.823 -1849.43 883.245 -1640.44 829.107C-1396.38 765.917 -1426.2 471.574 -1146.36 730.759C-921.437 939.135 -886.771 644.675 -725.578 564.374C-679.824 541.539 -660.564 466.551 -500.131 645.026C-218.423 958.524 -64.2925 271.082 499.239 834.187C576.858 911.744 1172.02 823.967 1271.35 599.589C1583.93 -106.774 1671.71 719.896 2037.8 803.936C2253.33 853.401 2638.22 819.821 2789.26 844.232L2789.31 844.232Z",
    stroke: "url(#paint26_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2846.51 843.473C2053.38 761.653 2236.99 1523.85 1715.42 963.429C1255.3 1087.88 1333.86 3052.62 649.926 1402.96C526.96 1106.4 32.002 1304.38 -114.425 1350.92C-226.361 1345.61 -271.474 1002.91 -319.038 979.081C-488.576 894.107 -675.33 853.46 -817.03 1140.74C-901.186 1311.33 -944.431 1356.06 -979.156 1360.5C-1013.88 1365 -1068.33 1340.7 -1121.96 1208.54C-1295.88 780.283 -1469.97 902.225 -1836.13 875.361C-2389.79 834.772 -1919.58 883.77 -1704.87 827.822C-1454.1 762.471 -1484.79 457.966 -1197.25 726.145C-966.2 941.587 -930.658 637.2 -764.914 554.095C-717.933 530.559 -698.149 452.885 -533.28 637.55C-243.869 961.736 -85.8281 250.525 493.577 833.195C573.298 913.321 1184.74 822.741 1286.87 590.537C1607.86 -139.246 1698.08 714.932 2074.39 801.891C2295.82 853.051 2691.27 818.302 2846.51 843.531L2846.51 843.473Z",
    stroke: "url(#paint27_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2903.76 842.772C2089.39 758.266 2277.96 1545.69 1742.44 966.7C1270.07 1095.24 1350.55 3125.85 648.467 1422C522.174 1115.56 14.0272 1320.14 -136.368 1368.27C-251.281 1362.78 -297.619 1007.46 -346.409 982.819C-520.44 895.042 -712.272 853.051 -857.707 1149.79C-944.139 1326.04 -988.493 1372.18 -1024.15 1376.85C-1059.81 1381.47 -1115.72 1356.35 -1170.81 1219.87C-1349.4 777.422 -1528.1 903.393 -1904.11 875.711C-2472.55 833.779 -1989.79 884.413 -1769.3 826.596C-1511.81 759.084 -1543.39 444.476 -1248.08 721.531C-1010.9 944.04 -974.545 629.666 -804.19 543.758C-755.984 519.463 -735.675 439.161 -566.37 629.958C-269.314 964.773 -107.246 229.909 487.916 832.085C569.738 914.84 1197.47 821.456 1302.4 581.426C1631.79 -171.776 1724.52 709.909 2110.99 799.731C2338.3 852.525 2744.38 816.667 2903.76 842.772Z",
    stroke: "url(#paint28_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2960.95 842.013C2125.4 754.82 2318.87 1567.42 1769.4 969.912C1284.72 1102.6 1367.18 3199.09 646.949 1441.04C517.388 1124.73 -4.00621 1335.91 -158.312 1385.55C-276.259 1379.89 -323.765 1011.96 -373.838 986.557C-552.364 895.976 -749.214 852.701 -898.443 1158.9C-987.093 1340.82 -1032.67 1388.42 -1069.26 1393.21C-1105.86 1397.99 -1163.23 1372.06 -1219.72 1231.2C-1402.97 774.502 -1586.28 904.62 -1972.11 876.003C-2555.3 832.786 -2060 884.997 -1833.79 825.369C-1569.59 755.696 -1602.1 430.985 -1299.03 716.976C-1055.73 946.552 -1018.55 622.249 -843.584 533.538C-794.153 508.484 -773.318 425.554 -599.578 622.483C-294.818 967.926 -128.84 209.352 482.139 831.034C566.061 916.417 1210.07 820.171 1317.86 572.374C1655.66 -204.246 1750.84 705.004 2147.46 797.687C2380.61 852.175 2797.31 815.149 2960.84 842.072L2960.95 842.013Z",
    stroke: "url(#paint29_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3018.15 841.312C2161.41 751.374 2359.78 1589.2 1796.36 973.183C1299.36 1109.96 1383.87 3272.33 645.432 1460.13C512.545 1134.02 -22.0397 1351.74 -180.256 1402.96C-301.179 1397.12 -349.852 1016.58 -401.268 990.411C-584.287 897.028 -786.157 852.409 -939.179 1168.07C-1030.1 1355.65 -1076.79 1404.71 -1114.32 1409.62C-1151.85 1414.52 -1210.67 1387.77 -1268.62 1242.59C-1456.55 771.698 -1644.47 905.846 -2040.1 876.354C-2638.12 831.793 -2130.2 885.639 -1898.28 824.143C-1627.37 752.309 -1660.75 417.494 -1349.92 712.363C-1100.49 949.005 -1062.49 614.774 -882.919 523.259C-832.203 497.446 -810.902 411.888 -632.726 614.949C-320.321 971.022 -150.317 188.736 476.478 829.983C562.443 917.935 1222.79 818.945 1333.39 563.264C1679.53 -236.776 1777.28 699.981 2184.05 795.526C2423.1 851.708 2850.42 813.572 3018.09 841.312L3018.15 841.312Z",
    stroke: "url(#paint30_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3075.34 840.611C2197.42 747.987 2400.69 1610.98 1823.33 976.453C1314.07 1117.38 1400.5 3345.56 643.915 1479.17C507.701 1143.19 -40.1312 1367.57 -202.199 1420.24C-326.099 1414.23 -375.997 1021.13 -428.639 994.09C-616.152 897.962 -823.099 851.942 -979.856 1177.12C-1073.06 1370.37 -1120.86 1420.89 -1159.32 1425.97C-1197.78 1431.05 -1258.06 1403.48 -1317.41 1253.92C-1510.01 768.778 -1702.54 907.072 -2107.97 876.704C-2720.76 830.8 -2200.35 886.223 -1962.65 822.916C-1685.03 748.922 -1719.29 403.945 -1400.75 707.749C-1145.19 951.457 -1106.32 607.24 -922.196 512.922C-870.255 486.349 -848.428 398.163 -665.817 607.357C-345.709 974.058 -171.735 168.12 470.817 828.873C558.883 919.453 1235.52 817.601 1348.91 554.153C1703.45 -269.306 1803.66 694.959 2220.65 793.423C2465.53 851.241 2903.47 811.995 3075.28 840.611L3075.34 840.611Z",
    stroke: "url(#paint31_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3133 835.122C2233.84 739.811 2442.07 1627.98 1850.76 974.876C1329.19 1119.89 1498.32 3379.37 642.864 1493.42C518.147 1141.96 -57.6981 1378.55 -223.676 1432.8C-350.552 1426.61 -403.077 1023.47 -455.601 993.098C-652.219 903.627 -853.68 849.722 -1020.13 1181.44C-1112.04 1381.99 -1164.57 1432.33 -1203.9 1437.53C-1243.3 1442.73 -1300.2 1412.36 -1365.85 1260.46C-1547.18 755.112 -1762.94 929.031 -2175.49 872.207C-2804.74 863.68 -2270.45 880.617 -2026.67 816.843C-1742.81 739.052 -1766.85 374.861 -1451.18 698.346C-1181.26 940.244 -1131.3 624.644 -961.064 497.854C-904.163 479.633 -877.9 373.285 -698.499 595.093C-357.73 960.743 -136.952 92.8413 465.564 823.091C562.851 908.824 1295.69 827.296 1364.9 540.37C1864.47 -233.681 1841.89 645.61 2257.65 786.649C2512.92 822.39 2956.98 805.746 3132.94 835.18L3133 835.122Z",
    stroke: "url(#paint32_radial_165_5834)",
    strokeOpacity: 0.4,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(720 875.5) rotate(-90) scale(2436.5 1453.98)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668024
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_165_5834",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331 -91.6551) rotate(90) scale(2382.61 4403.52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_165_5834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 984,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarBg);
export default __webpack_public_path__ + "static/media/solar-bg.ee91a4d8bc97de0dee86e42455ed68b7.svg";
export { ForwardRef as ReactComponent };